import React from 'react';
import { InputNumber } from 'antd';
import { AMOUNT_MAX, roundAmount } from 'util/amount';

interface Props {
  value: number | null;
  onChange: (value: number | null) => void;
  style?: React.CSSProperties;
  autoFocus?: boolean;
}

// Vacío es "sin monto": el campo es opcional y no hay monto por defecto.
// Hasta cuatro decimales: lo que pase de ahí se redondea. Sin precision fija,
// para que un entero no se muestre con ceros de más.
const AmountInput: React.FC<Props> = ({
  value,
  onChange,
  style,
  autoFocus,
}: Props) => (
  <InputNumber<number>
    prefix="$"
    min={0}
    max={AMOUNT_MAX}
    placeholder="Sin monto"
    autoFocus={autoFocus}
    style={{ width: 200, ...style }}
    value={value}
    onChange={(next) => onChange(next == null ? null : roundAmount(next))}
  />
);

export default AmountInput;
